var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.splitText()),function(word,key){return _c('span',{key:key,class:{
      highlight: _vm.includes(_vm.searchText, word),
    }},[_vm._v(" "+_vm._s(word)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }